import { useTLang } from '../../../../../../../intl/intl';

export function useFastFromOCCInfoLang() {
  return {
    alert: {
      description: useTLang({
        id: 'highDemand.stateOption.fastFromOCC.alert.description',
      }),
    },
    disclaimer: {
      first: {
        title: useTLang({
          id: 'highDemand.stateOption.fastFromOCC.disclaimer.first.title',
        }),
        description: useTLang({
          id: 'highDemand.stateOption.fastFromOCC.disclaimer.first.description',
        }),
      },
      second: {
        title: useTLang({
          id: 'highDemand.stateOption.fastFromOCC.disclaimer.second.title',
        }),
        description: useTLang({
          id:
            'highDemand.stateOption.fastFromOCC.disclaimer.second.description',
        }),
      },
    },
  };
}
